import { axiosInstance } from "../../utils";

const actions = {
  FETCH_CLASSIFICATIONS_REQUESTED: "FETCH_CLASSIFICATIONS_REQUESTED",
  FETCH_CLASSIFICATIONS_SUCCEEDED: "FETCH_CLASSIFICATIONS_SUCCEEDED",
  FETCH_CLASSIFICATIONS_FAILED: "FETCH_CLASSIFICATIONS_FAILED",

  FETCH_CLASSIFICATION_REQUESTED: "FETCH_CLASSIFICATION_REQUESTED",
  FETCH_CLASSIFICATION_SUCCEEDED: "FETCH_CLASSIFICATION_SUCCEEDED",
  FETCH_CLASSIFICATION_FAILED: "FETCH_CLASSIFICATION_FAILED",

  SEARCH_CLASSIFICATION_REQUESTED: "SEARCH_CLASSIFICATION_REQUESTED",
  SEARCH_CLASSIFICATION_SUCCEEDED: "SEARCH_CLASSIFICATION_SUCCEEDED",
  SEARCH_CLASSIFICATION_FAILED: "SEARCH_CLASSIFICATION_FAILED",

  DELETE_CLASSIFICATION_REQUESTED: "DELETE_CLASSIFICATION_REQUESTED",
  DELETE_CLASSIFICATION_SUCCEEDED: "DELETE_CLASSIFICATION_SUCCEEDED",
  DELETE_CLASSIFICATION_FAILED: "DELETE_CLASSIFICATION_FAILED",

  fetchClassifications: (id = undefined) => {
    return {
      type: actions.SEARCH_CLASSIFICATION_REQUESTED,
      payload: id,
    };
  },

  fetchClassification: (id = undefined) => {
    return {
      type: actions.FETCH_CLASSIFICATION_REQUESTED,
      payload: id,
    };
  },

  removeClassification: (id = undefined) => {
    return {
      type: actions.DELETE_CLASSIFICATION_REQUESTED,
      payload: id,
    };
  },

  getClassifications: async (params = undefined) => {
    const url = `classifications`;
    try {
      const classifications = await axiosInstance.get(url, { params });
      return classifications.data;
    } catch (error) {
      throw error;
    }
  },

  searchClassifications: async (params = {}) => {
    const url = `classifications`;

    // q param is required
    if (!params.q) params.q = "";

    try {
      const classifications = await axiosInstance.get(url, { params });
      return classifications.data;
    } catch (error) {
      throw error;
    }
  },

  getClassification: async (classificationId = undefined) => {
    const url = `classifications/` + classificationId;

    try {
      const classification = await axiosInstance.get(url);
      return classification.data;
    } catch (error) {
      throw error;
    }
  },

  deleteClassification: async (id = undefined) => {
    const url = `classifications/` + id;

    try {
      const response = await axiosInstance.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
export default actions;
